<div class="p-4 xl:p-10 flex-1 flex flex-col">
  <div class="telephone-validation">
    <div class="welcome flex flex-col gap-6 py-6">
      <div class="font-efSans-secondary font-semibold text-sm uppercase">
        {{ 'customer-portal' | sharedTranslate }}
      </div>
      <div class="font-canelablack-primary text-4xl md:text-5xl">
        <T
          str="Confirm mobile phone"
          key="customerPortal.kc.telephone-validation.title"
          tags="kc-forms, 3.1"
        >
        </T>
      </div>
      <customer-portal-kc-message></customer-portal-kc-message>
      <mat-card
        class="flex flex-row gap-6 items-center py-7 px-10 mb-5 border border-at-ef-revolution-supergrey-500 rounded-lg mat-elevation-z0"
      >
        <mat-icon
          class="card-flex-rounded-icon"
          svgIcon="phone_iphone"
        ></mat-icon>
        <!-- prettier-ignore -->
        <p
          class="m-0 justify-self-start items-center font-efSans-primary"
          [innerHTML]="getTranslation1()"
        ></p>
      </mat-card>
      <div class="py-10 px-0">
        <form
          class="grid grid-cols-3 md:grid-cols-7 gap-2.5 items-center"
          #telephoneValidationForm
          [action]="viewData.registrationAction"
          method="POST"
          [formGroup]="form"
        >
          <input
            #code0
            matInput
            placeholder="0"
            type="tel"
            autocomplete="off"
            formControlName="code0"
            minlength="1"
            maxlength="1"
            tabindex="0"
            (keypress)="isNumber($event)"
            (keyup)="keyup($event, 0)"
            (focus)="focus(0)"
            class="col-span-1 w-full lg:w-[72px] h-full md:h-[80px] p-4 text-6xl text-center border rounded-md text-mat-ef-revolution-primary-500"
          />
          <input
            #code1
            matInput
            placeholder="0"
            type="tel"
            autocomplete="off"
            formControlName="code1"
            minlength="1"
            maxlength="1"
            tabindex="1"
            (keypress)="isNumber($event)"
            (keyup)="keyup($event, 1)"
            (focus)="focus(1)"
            class="col-span-1 w-full lg:w-[72px] h-full md:h-[80px] p-4 text-6xl text-center border rounded-md text-mat-ef-revolution-primary-500"
          />
          <input
            #code2
            matInput
            placeholder="0"
            type="tel"
            autocomplete="off"
            formControlName="code2"
            minlength="1"
            maxlength="1"
            tabindex="2"
            (keypress)="isNumber($event)"
            (keyup)="keyup($event, 2)"
            (focus)="focus(2)"
            class="col-span-1 w-full lg:w-[72px] h-full md:h-[80px] p-4 text-6xl text-center border rounded-md text-mat-ef-revolution-primary-500"
          />
          <span
            class="text-7xl text-center text-mat-ef-revolution-grey-two-500 hidden md:block"
            >-</span
          >
          <input
            #code3
            matInput
            placeholder="0"
            type="tel"
            autocomplete="off"
            formControlName="code3"
            minlength="1"
            maxlength="1"
            tabindex="3"
            (keypress)="isNumber($event)"
            (keyup)="keyup($event, 3)"
            (focus)="focus(3)"
            class="col-span-1 w-full lg:w-[72px] h-full md:h-[80px] p-4 text-6xl text-center border rounded-md text-mat-ef-revolution-primary-500"
          />
          <input
            #code4
            matInput
            placeholder="0"
            type="tel"
            autocomplete="off"
            formControlName="code4"
            minlength="1"
            maxlength="1"
            tabindex="4"
            (keypress)="isNumber($event)"
            (keyup)="keyup($event, 4)"
            (focus)="focus(4)"
            class="col-span-1 w-full lg:w-[72px] h-full md:h-[80px] p-4 text-6xl text-center border rounded-md text-mat-ef-revolution-primary-500"
          />
          <input
            #code5
            matInput
            placeholder="0"
            type="tel"
            autocomplete="off"
            formControlName="code5"
            minlength="1"
            maxlength="1"
            tabindex="5"
            (keypress)="isNumber($event)"
            (keyup)="keyup($event, 5)"
            (focus)="focus(5)"
            class="col-span-1 w-full lg:w-[72px] h-full md:h-[80px] p-4 text-6xl text-center border rounded-md text-mat-ef-revolution-primary-500"
          />
          <input type="hidden" name="step" value="tel_validation" />
          <input type="hidden" name="validationCode" [value]="code" />
          <input
            type="hidden"
            name="telephoneNumber"
            [value]="viewData.telephoneNumber"
          />
        </form>
      </div>
      <div class="a-link">
        <span
          class="font-efSans-primary a-link"
          [innerHTML]="getTranslation2()"
        ></span
        >&nbsp;
        <a
          mat-button
          href="#"
          (click)="resend()"
          [disabled]="resendDisabled"
          class="p-0"
        >
          <ng-container *ngIf="!resendDisabled">
            <T
              str="Send the code again"
              key="customerPortal.kc.telephone-validation.resend.link"
              tags="kc-forms, 3.1"
            >
            </T>
          </ng-container>
          <ng-container *ngIf="resendDisabled">
            <T
              str="Repeat disabled."
              key="customerPortal.kc.telephone-validation.resend.link-disabled"
              tags="kc-forms, 3.1"
            >
            </T>
          </ng-container>
        </a>
        <p *ngIf="resendDisabled" class="center">
          <T
            str="Please try again later."
            key="customerPortal.kc.telephone-validation.resend.disabled-text"
            tags="kc-forms, 3.1"
          >
          </T>
        </p>
      </div>
    </div>
  </div>
</div>
